export const DROPDOWN_MENU_WIDTH = "200px";
export const IMPERSONATE_USER_LIST_HEIGHT = "25rem";
export const BUTTON_TAB_INDEX = 0;
